import { Typography } from '@ag1/ui';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import styles from './OfferPrice.module.scss';
import { OfferPriceItem } from '../types';

interface Props {
  coreProduct: OfferPriceItem;
  showOldPriceFirst: boolean;
}

export const CoreProductRow = ({ coreProduct, showOldPriceFirst }: Props) => {
  const { t } = useTranslation('offer');
  return (
    <div className={styles.tableRow}>
      <Typography
        color="black-new"
        variant="body"
        size="2"
        weight="700"
        noPadding
        className={styles.tableHeadline}>
        {coreProduct.name}
      </Typography>
      <Typography
        color="black-new"
        variant="portalCaption"
        size="1"
        noPadding
        className={styles.tableDescription}>
        {coreProduct.description}
      </Typography>
      <div className={clsx(styles.tablePrice, showOldPriceFirst && styles.flexRowReverse)}>
        {coreProduct.rawOriginalPrice > coreProduct.rawPrice && (
          <Typography
            color="black-new"
            variant="body"
            size="2"
            noPadding
            className={styles.tablePriceBasic}>
            <s>{coreProduct.originalPrice}</s>
            <sup>†</sup>
          </Typography>
        )}
        <Typography
          color="black-new"
          variant="body"
          size="2"
          weight="700"
          noPadding
          className={styles.tablePriceAlt}>
          {coreProduct.price}{' '}
          {coreProduct.isFirstMonthFree && `(${t('offerPrice.firstMonthFreeTag')})`}
        </Typography>
      </div>
    </div>
  );
};
